import moment from "moment";
import React, { useContext, useState } from "react";
import CameraModal from "../CameraModal";
import ReplyComponent from "../ReplyComponent";
import AttachmentModal from "../AttachmentModal";
import ChatInputField from "src/components/atoms/inputfields/ChatInputField";
import { formattedDate } from "src/services/functions/sendMessagefunction";
import { AdminDashboardContext } from "src/components/Context/MyContext";
import Cookies from "js-cookie";

const ChatInputComponent = ({ replyMessage, setReplyMessage, handleSendMsg, handleMedia }) => {
  const id = new Date().getTime() + Math.random().toString(36).substring(2, 24);
  const roleId = Cookies.get("roleId");
  const [share, setShare] = useState(false);
  const [showCamera, setShowCamera] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);

  const handleEnter = (message={}) => {
    if (message.trim() !== "") {
      handleSendMsg(message);
      setInputValue("");
    }
  };

  const handleUpload = (uploadData, duration = "0", cameraVideo = "") => {
    let { url, path, filename, type, thumbnail } = uploadData.data[0];
    handleMedia(url, path, filename, type, thumbnail, duration, cameraVideo);
  };
  return (
    <>
      {roleId !== "6" && roleId !== "7" && (
        <div className="ml-4 mr-5">
          {replyMessage ? (
            <ReplyComponent
              replyMessage={replyMessage}
              setReplyMessage={setReplyMessage}
              openAttachment={() => setShare(true)}
              inputValue={inputValue}
              setInputValue={setInputValue}
              handleEnter={handleEnter}
              loading={loading}
              handleUpload={handleUpload}
            />
          ) : (
            <ChatInputField
              openAttachment={() => setShare(true)}
              inputValue={inputValue}
              setInputValue={setInputValue}
              handleEnter={handleEnter}
              handleUpload={handleUpload}
              loading={loading}
            />
          )}
          {share && (
            <AttachmentModal
              open={share}
              close={() => setShare(false)}
              setShowCamera={() => setShowCamera(true)}
              setLoading={setLoading}
              handleUpload={handleUpload}
              setInputValue={setInputValue}
              loading={loading}
            />
          )}
          {showCamera && (
            <CameraModal
              showCamera={showCamera}
              setShowCamera={setShowCamera}
              handleUpload={handleUpload}
              setLoading={setLoading}
              close={() => setShare(false)}
              loading={loading}
            />
          )}
        </div>
      )}
    </>
  );
};

export default ChatInputComponent;
